<div class="input-component"
     [ngClass]="{'pristine': (pristine$ | async), 'valid': (validStatus$ | async), 'invalid': (invalidStatus$ | async), 'disabled': (disabled$ | async)}">
    <div class="input-wrapper no-border">
        <div class="input-combobox-label">
            <label [ngClass]="{'required':required}"
                   *ngIf="label"
                   [attr.for]="fieldId">{{label}}</label>
        </div>
        <div class="input-combobox-select"
             [formGroup]="formGroup">
            <ng-select class="aa-ng-select input-field"
                       [ngClass]="{'invalid': (invalidStatus$ | async)}"
                       [id]="fieldId"
                       [items]="items | async"
                       bindLabel="label"
                       bindValue="value"
                       [clearable]="true"
                       [searchable]="true"
                       (change)="onSelected()"
                       [addTag]="true"
                       addTagText="Validez la saisie"
                       formControlName="formControlName">
            </ng-select>
        </div>
        <div *ngIf="(dirtyStatus$ | async)">
            <span class="input-validation fa-stack fa-1x">
                <i class="fas fa-stack-2x fa-circle"
                   aria-hidden="true"></i>
                <i class="fal fa-stack-1x"
                   [ngClass]="{'fa-check': (validStatus$ | async), 'fa-times': (invalidStatus$ | async)}"
                   aria-hidden="true"></i>
            </span>
        </div>
    </div>
    <aa-validation2 [dirty]="dirty"
                    [messages]="failures | async">
    </aa-validation2>
</div>
